import styled from "styled-components";
import { device } from "../../themes/Breakpoints";

export const FooterWrapper = styled.footer`
  background: #022142;
  padding: 80px 10px 100px 10px;
  display: flex;
  justify-content: center;
  .footerInside{
    max-width: 1440px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .footer-logo {
      display: block;
      width: auto;
      height: 150px;
    }
  }
  .footer-link{
   color: #FFF;
   font-size: 16px;
   font-style: normal;
   font-weight: 500;
   line-height: 24px;
   margin-bottom: 24px;
 }
  .linksDiv{
    display: flex;
    flex-direction: column;
  }
  .inputDiv{
    max-width: 464px;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  input{
    padding: 16px 12px;
    border-radius: 4px;
    border: 1px solid #FFF;
    margin-bottom: 12px;
    width: 100%;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.5px;
    color: white;
    background-color:transparent;
  }
  input::placeholder{
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; 
    letter-spacing: 0.5px;
  }
  .inputDescription{
    color: #AFAFAF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 12px;
  }
  button{
    padding: 6px 24px;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    border-radius: 3px;
    background: #F15A24;
    cursor: pointer;
    align-self: flex-end;  
  }
   @media ${device.laptop} {
     .footerInside {
       flex-wrap: wrap;
       gap: 50px;
     }
   }
  @media ${device.tabletL} {
    .footerInside {
      flex-wrap: wrap;
      justify-content: center;
      gap: 50px;
    }
  }
  @media ${device.tablet} {
    .footerInside {
      flex-wrap: wrap;
      justify-content: center;
      gap: 50px;
    }
  }
  @media ${device.mobileL} {
    padding: 40px 24px;
    .footerInside {
      flex-wrap: wrap;
      justify-content: center;
      gap: 50px;
    }
  }
  @media only screen and (max-width: 424px) {
    padding: 40px 24px;
    .footerInside {
      flex-direction: column;
      align-items: center;
      gap: 20px;
      .footer-logo {
        height: 72px;
      }
    }
    
  }
  
`;